// extracted by mini-css-extract-plugin
export var actions = "_ub-4";
export var item = "_ub-1";
export var price = "_ub-3";
export var quantity = "_ub-2";
export var table = "_ub-0";